import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import useBreakpoints from '@exchange/libs/composables/shared/src/lib/useBreakpoints';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

import OpenOrdersListDesktop from './desktop/OpenOrdersListDesktop.vue';
import OpenOrdersListMobile from './mobile/OpenOrdersListMobile.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenOrders',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  dragging: { type: Boolean, required: true },
  marketId: { type: String, required: true },
  showAllMarkets: { type: Boolean, required: true },
},
  setup(__props) {



const breakpoints = {
  780: 'hide-type compact-side hide-currency compact-status', // 'compact-side compact-order-type hide-time hide-currency compact-status compact-order-type',
  850: 'hide-type compact-side', // 'compact-side compact-order-type hide-time compact-order-type',
  880: 'hide-type compact-side', // 'compact-side compact-order-type compact-order-type',
  920: 'hide-type compact-side', // 'compact-side compact-order-type',
  bigger: 'hide-type',
};

/* eslint-disable compat/compat */
// @ts-ignore Wait for a proper Houdini API support
const houdiniApiSupported = !!(window.CSS && window.CSS.registerProperty);
const { currentBreakPoint, watchedEl: wrapperRef } = useBreakpoints(breakpoints);
const { isXS } = useMQBreakpoints();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapperRef",
    ref: wrapperRef,
    class: _normalizeClass(["open-orders", { 'open-orders--houdini-api-not-supported': !houdiniApiSupported }])
  }, [
    (!_unref(isXS))
      ? (_openBlock(), _createBlock(OpenOrdersListDesktop, {
          key: 0,
          class: "open-orders__list",
          "show-order-type": false,
          breakpoint: _unref(currentBreakPoint),
          dragging: __props.dragging,
          "market-id": __props.marketId,
          "show-all-markets": __props.showAllMarkets,
          "authenticated-user": __props.authenticatedUser
        }, null, 8, ["breakpoint", "dragging", "market-id", "show-all-markets", "authenticated-user"]))
      : (_openBlock(), _createBlock(OpenOrdersListMobile, {
          key: 1,
          class: "open-orders__list",
          "show-order-type": false,
          "market-id": __props.marketId,
          "show-all-markets": __props.showAllMarkets,
          "authenticated-user": __props.authenticatedUser
        }, null, 8, ["market-id", "show-all-markets", "authenticated-user"]))
  ], 2))
}
}

})